import { Block, BlockDefinition, BlockType } from './types'
import titleBlock from './blocks/title'
import textBlock from './blocks/text'
import imageBlock from './blocks/image'
import imageTextBlock from './blocks/imageText'
import mediaBlock from './blocks/media'

// Every block type a doclet can contain. Adding a block type means adding its
// props to BlockPropsByType (types.ts) and its definition here.
export const blockRegistry: { [T in BlockType]: BlockDefinition<T> } = {
  title: titleBlock,
  text: textBlock,
  image: imageBlock,
  imageText: imageTextBlock,
  media: mediaBlock
}

export const getBlockDefinition = <T extends BlockType>(type: T) =>
  blockRegistry[type] as BlockDefinition<T> | undefined

export const createBlock = <T extends BlockType>(
  type: T,
  id: string
): Block<T> => ({
  id,
  type,
  props: blockRegistry[type].createDefaultProps()
})

// Whether the block offers the full width setting, given what it holds
export const supportsFullWidth = (block: Block): boolean => {
  const supports = getBlockDefinition(block.type)?.supportsFullWidth as
    | boolean
    | ((props: Block['props']) => boolean)
    | undefined
  return typeof supports === 'function' ? supports(block.props) : !!supports
}

// Whether the block runs to the page's edges: set, and supported
export const isFullWidth = (block: Block): boolean =>
  !!block.fullWidth && supportsFullWidth(block)
